function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3A5C",
  d: "M21 0c11.592.014 20.986 9.408 21 21 0 11.598-9.402 21-21 21S0 32.598 0 21 9.402 0 21 0zm0 3.5C11.335 3.5 3.5 11.335 3.5 21S11.335 38.5 21 38.5c9.66-.01 17.49-7.84 17.5-17.5 0-9.665-7.835-17.5-17.5-17.5zm-.875 6.125c.966 0 1.75.784 1.75 1.75v8.857l8.11 7.436a1.75 1.75 0 01.108 2.47 1.767 1.767 0 01-2.473.107l-8.678-7.954A1.75 1.75 0 0118.375 21v-9.625c0-.966.784-1.75 1.75-1.75z"
});

function SvgTimerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42
  }, props), _ref);
}

export default SvgTimerIcon;